export const BaseUrls = {
  config: 'config/app/v1',
  account: 'account/v1',
  tenant: 'tenant/v1',
  otpMsg: 'msg/otp/v1',
  user: 'account/user/v1',
  locale: 'combo/locale/v1',
  currency: 'combo/currency/v1',
  country: 'combo/country/v1',
  role: "role/v1",
  attachment: "attachment/v1",
  attachmentGroup: "attachment/group/v1",
  homePage: "page/home/v1",
  webPage: "page/web/v1",
  userNotification: "notification/account/v1",
  sendNotification: "notification/send/v1",
  issue: "issue/v1",
  predefinedIssue: "issue/predefined/v1",
  export: "export/v1",
  dashboard: "dashboard/v1",
  report: "report/v1",
  reportView: "report/view/v1",
  contactUs: "contactus/v1",
  paymentProvider: "payment/provider/v1",
  paymentHistory: "payment/history/v1",
}

export const BaseUrl = {
  get: name => BaseUrls[name],
}
